import { createTag, type BaseApi, type CacheTag, type CreateTagInput } from '@frontend/api-client/utils';
import { baseApi } from '@frontend/web/redux';
import { useDispatch } from './useDispatch';

export const useDispatchApi = () => {
  const dispatch = useDispatch();

  const dispatchApi = (fn: (_: BaseApi) => ReturnType<typeof dispatch>) => dispatch(fn(baseApi));

  const invalidateCache = (tags: CreateTagInput<CacheTag>[]) => {
    dispatchApi((baseApi) => baseApi.util.invalidateTags(tags.map(createTag)));
  };

  return {
    dispatchApi,
    invalidateCache,
  };
};
